export default "__VITE_ASSET__b5015e06__"